import Container from "~/components/atoms/Container";
import Breadcrumbs from "../BreadCrumbs";
import { DEFAULT_COUNTRY, DEFAULT_REGION } from "~/lib/constants/generalConstants";
import { getCountryName, getFormattedCountryName } from "~/lib/helpers/constants";
import ContactForm from "../ContactPage/ContactForm";
import MobileHeroBanner from "../ContactPage/MobileHeroBanner";
import { useLocation } from "@remix-run/react";
import HeroBannerRoundEdge from "../HeroBanners/HeroBannerRoundEdge";
import { useMemo } from "react";


export default function CoStats({ region, isMobile, country }) {
    const IframeUrl = `https://officehub.my.salesforce-sites.com/Analytics?country=${getCountryName(region).toLowerCase()}`;

    const iframeHeading = `${getCountryName(region)}'s Serviced & Coworking Market Report`;
    const location = useLocation();
    let { pathname } = location;
    const getImageKitUrlEndpoint = (): string => {
        if (typeof window !== "undefined" && (window as any).ENV?.PUBLIC_REMIX_APP_IMAGEKIT_URL_ENDPOINT) {
            return (window as any).ENV.PUBLIC_REMIX_APP_IMAGEKIT_URL_ENDPOINT;
        }
        return "https://ik.imagekit.io/officehub";
    };
    const imageKitUrlEndpoint = useMemo(() => getImageKitUrlEndpoint(), []);
    return (
        <>
            <Container htmlFor='ultra-wide'>
                <nav className='hidden md:block py-4' aria-label='Breadcrumb'>
                    <Breadcrumbs
                        params={{ country: region || DEFAULT_REGION, countryRequired: false }}
                    />
                </nav>
            </Container>
            <div className="bg-gray-50">

                {isMobile ? (
                    <MobileHeroBanner
                        title="Co-Stats - Office Hub's live coworking market database"
                        description="Statistics and insights for the coworking and flexible office industry.ant to get in touch? We'd love to hear from you. Here's how you can reach us."
                        image={`https://office-hub.s3.ap-southeast-2.amazonaws.com/site/assets/co-stats/costats.avif`}

                    />
                ) : (
                    <HeroBannerRoundEdge
                        title="Co-Stats - Office Hub's live coworking market database"
                        image="https://office-hub.s3.ap-southeast-2.amazonaws.com/site/assets/co-stats/costats.avif"
                        html="Office Hub's Co-Stats tracks and reports on the entire flexible workspace market in realtime so you always have access to the latest statistics, numbers and results for our industry. Our data is updated dynamically on a monthly basis so you can search for the facts you need, when you need them."
                    />
                )
                }


            </div>
            <div className="py-4">
                <Container htmlFor='ultra-wide'>
                    <section className="max-w-7xl mx-auto px-6 md:mx-0 md:px-0 py-4 md:py-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                        <div>
                            <img
                                src="https://office-hub.s3.ap-southeast-2.amazonaws.com/site/assets/co-stats/co-statsBanner.avif"
                                alt='partners image'
                                className='h-full w-full rounded-lg'
                            />
                        </div>
                        <div className="space-y-3">

                            <div className="space-y-4 text-gray-700 text-base">
                                <h2 className="text-3xl font-semibold text-gray-900">
                                    How to use Co-Stats
                                </h2>
                                <p className="flex items-start space-x-4 text-gray-700 text-base">
                                    <img
                                        src={`${imageKitUrlEndpoint}/tr:w-120,fo-auto,f-avif/https://d6yg2sphm6jrv.cloudfront.net/img/oh-web-icons-location-pointer-with-star-in-target-inside.gif`}
                                        width="60"
                                        alt="Location icon"
                                    />
                                    <span>
                                        <h3 className="font-bold">1. Select Country and Area</h3>
                                        What part of the world are you researching? Select a Country to see available areas.
                                    </span>
                                </p>

                                <div className="flex items-start space-x-4 text-gray-700 text-base">
                                    <img
                                        src={`${imageKitUrlEndpoint}/tr:w-120,fo-auto,f-avif/https://d6yg2sphm6jrv.cloudfront.net/img/oh-web-icons-3-people-standing-facing-forward.gif`}
                                        width="60"
                                        alt="People icon"
                                    />
                                    <span>
                                        <h3 className="font-bold">2. Select Segment</h3>
                                        Jump between supply, demand and results to explore the entire market in your selected area.
                                    </span>
                                </div>

                                <p className="flex items-start space-x-4 text-gray-700 text-base">
                                    <img
                                        src={`${imageKitUrlEndpoint}/tr:w-120,fo-auto,f-avif/https://d6yg2sphm6jrv.cloudfront.net/img/oh-web-icons-hand-chat-bubble-dollar-sign-star-rating.gif`}
                                        width="60"
                                        alt="Chat bubble icon"
                                    />
                                    <span>
                                        <h3 className="font-bold">3. Reference Office Hub</h3>
                                        Don't forget to reference Office Hub, the date of your report and link this page when using our statistics.
                                    </span>
                                </p>

                            </div>
                        </div>
                    </section>

                    <div className="row">
                        <h2 className=" font-semibold text-xl mb-2 px-4 md:px-0">
                            {iframeHeading}
                        </h2>
                        <div className="col-12 h-[4150px] w-full">
                            <div className="embed-responsive embed-responsive-16by9 my-3 h-full">
                                <iframe
                                    width="100%"
                                    height="100%"
                                    allowFullScreen
                                    frameBorder="0"
                                    src={IframeUrl}
                                    className="lazyload embed-responsive-item"
                                />
                            </div>
                        </div>
                    </div>

                </Container>
                <section className='py-16 lg:py-24'>
                    <Container htmlFor='ultra-wide'>
                        <div className='flex flex-col lg:flex-row rounded-lg overflow-hidden bg-gray-50 max-w-[1400px] mx-auto mt-10 border border-gray-100 items-stretch'>

                            {/* Text & Form Section */}
                            <div className='w-full lg:w-3/5 p-8 sm:p-10 flex flex-col bg-gray-50'>
                                <div className='mb-8'>
                                    <p className='text-xl font-bold text-oh-black mb-2 tracking-tight'>
                                        Fill the form to Contact us
                                    </p>
                                    <p className='text-oh-black text-base'>
                                        Contact Office Hub {getFormattedCountryName(region || DEFAULT_REGION)}. Fill out the form to connect with local experts and find flexible coworking or serviced offices across the country.

                                    </p>
                                </div>
                                <div className='flex-1 overflow-hidden'>
                                    <ContactForm
                                        canonicalCountry={getCountryName(region) || DEFAULT_COUNTRY}
                                        region={region}
                                        path={pathname}
                                    />
                                </div>
                            </div>

                            <div
                                className="hidden lg:block lg:w-2/5 bg-no-repeat bg-cover"
                                style={{
                                    backgroundImage: `url(${imageKitUrlEndpoint}/tr:h-800,w-1200,f-avif/${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/contact-us/contact-us.avif)`,
                                    backgroundPosition: "right -90px bottom 0px",
                                }}
                            />
                        </div>
                    </Container>
                </section>

            </div>
        </>
    )
}